import React from 'react';
import { Typo } from '.';
import { Variants } from './Typo';

const Pill = ({ children }) => (
    <div className="pill">
        <Typo.Caption variant={Variants.DARK}>
            {children}
        </Typo.Caption>
    </div>
);
const Green = ({ children }) => (
    <div className="pill pill--green">
        <Typo.Caption variant={Variants.SUCCESS}>
            {children}
        </Typo.Caption>
    </div>
);
Pill.Green = Green;
export default Pill;